import { render, staticRenderFns } from "./wave-banner.vue?vue&type=template&id=bfade8ba&"
import script from "./wave-banner.vue?vue&type=script&lang=js&"
export * from "./wave-banner.vue?vue&type=script&lang=js&"
import style0 from "./wave-banner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports